module.exports = __webpack_public_path__ + "static/media/seat-plan-qr.efbe250e.png";